import { render, staticRenderFns } from "./TrueFalse.vue?vue&type=template&id=799aedde&"
import script from "./TrueFalse.vue?vue&type=script&lang=js&"
export * from "./TrueFalse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports